import { StandardPlot } from "../core/objects/svg/standard-plot";
import { OfflineDataPlotObjectGroup } from "./offline-data-plot-object-group";

export class OfflineDataPlot extends StandardPlot {
  constructor(settings) {
    super(settings);
  }

  init() {
    this.specificPlotObjects = new OfflineDataPlotObjectGroup(this);
    super.init();
    this.specificPlotObjects.initCursorAndMeasurer();
    this.specificPlotObjects.startUpdateMeanValues();
  }

  setOnSelectChannel(action) {
    this.onSelectChannel = (dataSourceId, channelId) => {
      this.specificPlotObjects.updateCursorAndMeasurerPosition(false);
      action(dataSourceId, channelId);
    };
  }

  setCursorOrMeasurerPosition(x) {
    this.specificPlotObjects.setCursorOrMeasurerPosition(x);
  }

  setOnCursorPositionChanged(action) {
    this.specificPlotObjects.setOnCursorPositionChanged(action);
  }

  setOnMeasurerPositionChanged(action) {
    this.specificPlotObjects.setOnMeasurerPositionChanged(action);
  }

  afterSignalObjectCreate(signalObject, dataSourceId, channelId, signalId) {
    this.specificPlotObjects.initUpdateMeanValueFunctions(signalObject, dataSourceId, channelId, signalId);
  }

  setOnBufferSizeChanged(action) {
    this.onBufferSizeChanged = action;
  }

  afterAddPointsToChannels() {}

  // points in user units (e.g. mV) or in pixels (if valueConverter is not set)
  afterAddPointsToSignal() {
    this.specificPlotObjects.updateCursorAndMeasurerPosition();
  }

  setFilters(selectedFilterNames) {
    super.setFilters(selectedFilterNames);
    this.specificPlotObjects.updateMeanValues();
  }

  setChannelFilters(dataSourceId, channelId, selectedFilterNames) {
    super.setChannelFilters(dataSourceId, channelId, selectedFilterNames);
    this.specificPlotObjects.updateMeanValues();
  }

  setOnMeasurerSpaceBetweenLinesChanged(action) {
    this.specificPlotObjects.setOnMeasurerSpaceBetweenLinesChanged(action);
  }

  convertMsToPixels(ms) {
    return this.specificPlotObjects.convertMsToPixels(ms);
  }

  convertPixelsToMs(pixels) {
    return this.specificPlotObjects.convertPixelsToMs(pixels);
  }

  getSignalWidthInPixels() {
    return this.specificPlotObjects.getSignalWidthInPixels();
  }

  getSignalWidthInMs() {
    return this.specificPlotObjects.getSignalWidthInMs();
  }

  getSpaceBetweenLines() {
    return this.specificPlotObjects.getSpaceBetweenLines();
  }

  setSpaceBetweenLines(widthInPixels) {
    this.specificPlotObjects.setSpaceBetweenLines(widthInPixels);
  }

  changeMeasurerMode() {
    this.specificPlotObjects.changeMeasurerMode();
  }

  getKeybordEventHanlder() {
    return this.specificPlotObjects.getKeybordEventHanlder();
  }

  afterChannelsDataClear() {}

  afterChannelDataUpdated() {}
}
